import { ComponentProps, ReactNode } from 'react';
import { Checkbox } from 'antd';
import clsx from 'clsx';
import { OpInfoTooltip } from '../OpInfoTooltip/OpInfoTooltip';

import './OpCheckbox.scss';

interface IOpCheckboxGroupProps extends ComponentProps<typeof Checkbox.Group> {
  testId?: string;
}

const OpCheckboxGroup = ({
  className,
  testId = 'op-checkbox-group',
  ...checkboxGroupProps
}: IOpCheckboxGroupProps) => {
  return (
    <Checkbox.Group
      className={clsx('op-checkbox-group', className)}
      data-testid={testId}
      {...checkboxGroupProps}
    />
  );
};

interface IOpCheckboxProps extends ComponentProps<typeof Checkbox> {
  gtm?: string;
  testId?: string;
  tooltip?: ReactNode;
}

export const OpCheckbox = ({
  gtm,
  testId = 'op-checkbox',
  children,
  className,
  tooltip,
  ...checkboxProps
}: IOpCheckboxProps) => {
  return (
    <Checkbox
      data-gtm={gtm}
      data-testid={testId}
      className={clsx('op-checkbox', className)}
      {...checkboxProps}
    >
      {children}
      {tooltip && <OpInfoTooltip title={tooltip} />}
    </Checkbox>
  );
};

// Add sub-components from the antd component to our version
OpCheckbox.Group = OpCheckboxGroup;
